import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiRequest from "../Common/restservice";
import { errorToast, successToast } from "../Common/showtoast";
import ImageWithFallback from "../Components/ImageWithFallback";
import feather from 'feather-icons'

function KYCAadhar() {
  const [stateObj, setStateObj] = useState({});
  const navigate = useNavigate();
  useEffect(() => {
    GetKYC();
  }, []);
  useEffect(()=>{
    feather.replace();
  },[stateObj])
  const GetKYC = async (e) => {
    let res = await ApiRequest("GetKYC_Aadhar.asp", "GET", null, {
      Authorization: localStorage.getItem("token"),
    });
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }
    setStateObj(res);
  };
  const UploadKYC = async (e) => {
    if (!stateObj.aadharnumber || stateObj.aadharnumber.length !== 12) {
      return errorToast("Enter valid ID Card number");
    } else if (!stateObj.aadharfrontimg) {
      return errorToast("Select valid ID Card front img");
    } else if (!stateObj.aadharbackimg) {
      return errorToast("Select valid ID Card back img");
    }
    const formData = new FormData();
    formData.append("profileimage", stateObj.aadharfrontimg);
    formData.append("profileimageback", stateObj.aadharbackimg);
    formData.append("Aadhar", stateObj.aadharnumber);
    formData.append("token", localStorage.getItem("token"));
    let res = await ApiRequest(
      "uploadaadhar.asp",
      "POST",
      formData,
      { Authorization: localStorage.getItem("token") },
      false
    );
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }
    successToast(res.message);
    GetKYC();
  };
  return (
    <div className="card" style={{ height: "100%" }}>
      <div className="card-header">
        <h3>ID Card Verification</h3>
      </div>
      <div className="card-body">
        {stateObj.KycStatus === "Waiting for Approval" && (
          <div
            className="mt-auto mb-auto"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              height: "100%",
            }}
          >
            <button
                className="btn btn-warning"
                style={{ borderRadius: 30, fontSize: 20 }}
              >
                <i data-feather="info" />
              </button>
              <h4>
                Information has been updated. Please wait for admin to verify.
              </h4>
          </div>
        )}
        {(stateObj.KycStatus === "Verified" || stateObj.KycStatus === "Approved") && (
          <div
            className="content"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <div>
              <button
                className="btn btn-primary"
                style={{ borderRadius: 30, padding: "15px 20px", fontSize: 20 }}
              >
                <i data-feather="shield" />
              </button>
              <h3>ID Card Verification Completed Successfully.</h3>
            </div>
          </div>
        )}
        {(!stateObj.KycStatus ||
          stateObj.KycStatus === "File Not Uploaded" ||
          stateObj.KycStatus === "Rejected") && (
          <div
            className="content"
            style={{ display: "flex", flexWrap: "wrap" }}
          >
            {stateObj.KycStatus === "Rejected" && (
              <div
                className="col-lg-12"
                style={{
                  flexDirection: "column",
                  justifyContent: "center",
                  textAlign: "center",
                  marginBottom: 20,
                }}
              >
                <div>
                  <button
                    className="btn btn-danger"
                    style={{
                      borderRadius: 30,
                      padding: "15px 20px !important",
                      fontSize: 20,
                    }}
                  >
                    <i data-feather="x-circle" />
                  </button>
                  <h3>Rejected : {stateObj.rejectmessage}</h3>
                </div>
              </div>
            )}
            <div className="col-lg-12">
              <label htmlFor="aadharnumber">ID Card Number:</label>
              <input
                type="text"
                id="aadharnumber"
                name="aadharnumber"
                className="form-control"
                onChange={(e) => {
                  if (Number(e.target.value) || !e.target.value)
                    setStateObj({
                      ...stateObj,
                      aadharnumber: e.target.value,
                    });
                }}
                value={stateObj.aadharnumber}
              />
              <div className="row" style={{ marginTop: 10 }}>
                <div className="col-lg-6">
                  <label>ID Card Front : </label>
                  <br />
                  <label htmlFor="aadharfront">
                    <ImageWithFallback
                      style={{ height: 150, width: "100%" }}
                      src={stateObj.aadharfrontimgpreview}
                    />
                  </label>
                  <input
                    hidden
                    style={{ display: "none" }}
                    type="file"
                    id="aadharfront"
                    accept="image/jpg,image/jpeg"
                    onChange={(e) => {
                      setStateObj({
                        ...stateObj,
                        aadharfrontimg: e.target.files[0],
                        aadharfrontimgpreview: URL.createObjectURL(
                          e.target.files[0]
                        ),
                      });
                    }}
                  />
                </div>
                <div className="col-lg-6">
                  <label>ID Card Back : </label>
                  <br />
                  <label htmlFor="aadharback">
                    <ImageWithFallback
                      style={{ height: 150, width: "100%" }}
                      src={stateObj.aadharbackimgpreview}
                    />
                  </label>
                  <input
                    hidden
                    style={{ display: "none" }}
                    type="file"
                    id="aadharback"
                    accept="image/jpg,image/jpeg"
                    onChange={(e) => {
                      setStateObj({
                        ...stateObj,
                        aadharbackimg: e.target.files[0],
                        aadharbackimgpreview: URL.createObjectURL(
                          e.target.files[0]
                        ),
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <div
              className="btn-container"
              style={{ marginTop: 10, marginLeft: 20 }}
            >
              <button
                className="btn btn-primary"
                onClick={() => {
                  UploadKYC();
                }}
              >
                Submit
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default KYCAadhar;
